import createMessage from "./createMessage";
import CameraAlarmStatusBuilder from "../private/CameraAlarmStatus";

const name = "cameraAlarmStatus";

function create({ state }: { state: AlarmState }) {
  const payload = CameraAlarmStatusBuilder.create({ state });
  return createMessage({ [name]: payload });
}

const cameraAlarmStatus = { create, name };

export default cameraAlarmStatus;
